module.exports = __webpack_public_path__ + "5dbb2f87f3174bde3dc942850657892d.png";